// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay div.cart-service{display:flex;justify-content:space-between;align-items:center}#openbay div.cart-service p.notes{font-size:.85rem;margin-bottom:0;white-space:pre-line}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
